const isSm = window.innerWidth < 768;

export const monitoringConfig: Partial<Record<WidgetKey, WidgetConfig>> = {
    financialKgx: {
        width: isSm ? 300 : 350,
        widgetId: 'widget-container',
        isTransparent: false,
        colorTheme: 'light',
        useContainerSize: false,
        defaultItem: 'Gold',
        defaultView: 'text',
        defaultShowChange: false,
    },
    compactPrice: {
        widgetId: "widget-container-metal-bid",
        width: 300,
        isTransparent: false,
        colorTheme: 'light',
        defaultItem: "Gold",
        useContainerSize: false,
    }, 
    commodityTable: {
        widgetId: "widget-container-comodity",
        width: 300,
        isTransparent: false,
        colorTheme: 'light',
        defaultCategory: "Precious Metals",
        useContainerSize: false,
    },
    goldBid: {
        widgetId: "widget_compact_price",
        width: 300,
        isTransparent: false,
        colorTheme: 'light',
        useContainerSize: false,
    },
    spotPrice: {
        widgetId: "widget_spot_price",
        width: 300,
        isTransparent: false,
        colorTheme: 'light',
        useContainerSize: false,
    },
    londonFix: {
        widgetId: "widget_london_fix",
        width: isSm ? 300 : 400,
        isTransparent: false,
        colorTheme: 'light',
        useContainerSize: false,
    },
    crossRates: {
        widgetId: "widget_cross_rates",
        width: isSm ? 300 : 600,
        isTransparent: false,
        colorTheme: 'light',
        useContainerSize: false,
        defaultUnit: "Troy Ounces",
        defaultShowChange: false,
        defaultCurrencyList: ['USD', 'AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'EUR', 'GBP', 'HKD', 'INR', 'JPY', 'MXN', 'RUB', 'ZAR'],
    },
    threeDaysCharts: {
        widgetId: "widget_three_days_charts",
        width: 300,
        isTransparent: false,
        colorTheme: 'light',
        defaultMetal: "AU",
        useContainerSize: false,
    },
    NYChart: {
        widgetId: "widget_ny_chart",
        width: isSm ? 300 : 400,
        isTransparent: false,
        colorTheme: 'light',
        defaultMetal: "AU",
        useContainerSize: false,
    },
    preciousMetalsChart: {
        widgetId: "widget_precious_metals_chart",
        width: 300,
        isTransparent: false,
        colorTheme: 'light',
        defaultMetal: "AU",
        useContainerSize: false,
    }, 
    baseMetalsCharts: {
        widgetId: "widget_base_metals_charts",
        width: 300,
        isTransparent: false,
        colorTheme: 'light',
        defaultMetal: "CU",
        useContainerSize: false,
    },
    brandedMetalPerformance: {
        widgetId: "widget_branded_metal_performance",
        width: isSm ? 300 : 400,
        isTransparent: false,
        colorTheme: 'light',
        defaultMetal: "AU",
        defaultUnit: "Troy Ounces",
        defaultCurrency: "USD",
        useContainerSize: false,
    },
    metalPricePerformance: {
        widgetId: "widget_metal_price_performance",
        width: isSm ? 300 : 600,
        isTransparent: false,
        colorTheme: 'light',
        useContainerSize: false,
        defaultAllMetals: "AU",
        defaultShowChange: false,
        defaultCurrencyList: ['USD', 'AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'EUR', 'GBP', 'HKD', 'INR', 'JPY', 'MXN', 'RUB', 'ZAR'],
    },
    news: {
        widgetId: "widget_news",
        width: isSm ? 300 : 400,
        isTransparent: false,
        colorTheme: 'light',
        defaultNews: "all",
        useContainerSize: false,
    },
    calculator: {
        widgetId: "widget_calculator",
        width: isSm ? 300 : 400,
        isTransparent: false,
        colorTheme: 'light',
        defaultMetal: "AU",
        defaultUnit: "Troy Ounces",
        defaultCurrency: "USD",
        useContainerSize: false,    
    },
    ticker: {
        widgetId: "widget_ticker",
        width: isSm ? 300 : 1000,
        isTransparent: false,
        colorTheme: 'light',
        defaultTicker: ['AU', 'AG', 'PT', 'PD', 'GSR', 'BTC', 'ETH'],
        useContainerSize: false,
    },
};

